let scriptPromise = null;

function readSdkFromWindow() {
  if (typeof window === "undefined") return null;
  return window.ExotelCRMWebSDK || window.ExotelCRMWebSdk || null;
}

function loadScript(src) {
  if (typeof document === "undefined") {
    return Promise.reject(new Error("no_document"));
  }
  const existing = document.querySelector(`script[data-exotel-crm-sdk="1"]`);
  if (existing && readSdkFromWindow()) return Promise.resolve(readSdkFromWindow());
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = src;
    el.async = true;
    el.dataset.exotelCrmSdk = "1";
    el.onload = () => {
      const sdk = readSdkFromWindow();
      if (sdk) resolve(sdk);
      else reject(new Error("sdk_global_missing"));
    };
    el.onerror = () => reject(new Error("sdk_script_failed"));
    document.head.appendChild(el);
  });
  return scriptPromise;
}

/**
 * Exotel CRM WebRTC SDK only (no Daily / Agora / Twilio).
 */
export async function loadExotelCrmWebSDK() {
  const fromWindow = readSdkFromWindow();
  if (fromWindow) return fromWindow;
  try {
    const mod = await import("@exotel-npm-dev/exotel-ip-calling-crm-websdk");
    return mod?.default || mod?.ExotelCRMWebSDK || readSdkFromWindow();
  } catch {
    await loadScript("/exotel/crmBundle.js");
    const sdk = readSdkFromWindow();
    if (sdk) return sdk;
    throw new Error("sdk_unavailable");
  }
}
